export default [
  {
    path: '/psicossocial',
    name: 'psicossocial',
    component: () => import('@/views/AvaliacaoPsicossocial/MapeamentosPsicossociais.vue'),
    meta: { requiresAuth: true, appBar: true, footerMenu: true }
  },
  {
    path: '/psicossocial/respostas/:idMapeamento',
    name: 'psicossocial-respostas',
    component: () => import('@/views/AvaliacaoPsicossocial/AvaliacaoPsicossocialRespostas.vue'),
    meta: { requiresAuth: true, appBar: true, footerMenu: true },
    props: true
  },
  {
    path: '/avaliacao-psicossocial',
    name: 'avaliacao-psicossocial',
    component: () => import('@/views/AvaliacaoPsicossocial/AvaliacaoPsicossocial.vue'),
    meta: { requiresAuth: true, appBar: false, footerMenu: false },
    children: [
      {
        name: 'Avaliação Psicossocial',
        path: '',
        component: () => {
          return import('@/views/AvaliacaoPsicossocial/AvaliacaoPsicossocialBemVindo.vue')
        },
        meta: { requiresAuth: true, appBar: true, footerMenu: true }
      },
      {
        path: 'perguntas',
        component: () => import('@/views/AvaliacaoPsicossocial/AvaliacaoPsicossocialPerguntas.vue'),
        meta: { appBar: false, footerMenu: false, progressCircular: true, psicossocialPreenchimento: true }
      },
      {
        path: 'finalizar',
        component: () => import('@/views/AvaliacaoPsicossocial/AvaliacaoPsicossocialFinalizar.vue'),
        meta: { appBar: true, footerMenu: true }
      }
    ]
  }
]
